module.exports = __webpack_public_path__ + "media/images/case_image03-3181a1b2.png";